import { render, staticRenderFns } from "./restoreModal.vue?vue&type=template&id=44213138&"
import script from "./restoreModal.vue?vue&type=script&lang=js&"
export * from "./restoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports